import(/* webpackMode: "eager", webpackExports: ["useUser"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@auth0/nextjs-auth0/dist/client/hooks/use-user.js");
;
import(/* webpackMode: "eager", webpackExports: ["Auth0Provider"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@auth0/nextjs-auth0/dist/client/providers/auth0-provider.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/button/button.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/checkbox/checkbox.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/close-button/close-button.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/combobox/combobox.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/data-interactive/data-interactive.js");
;
import(/* webpackMode: "eager", webpackExports: ["Description"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/description/description.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/dialog/dialog.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/disclosure/disclosure.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/field/field.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/fieldset/fieldset.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/focus-trap/focus-trap.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/input/input.js");
;
import(/* webpackMode: "eager", webpackExports: ["Label"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/label/label.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/legend/legend.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/listbox/listbox.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/menu/menu.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/popover/popover.js");
;
import(/* webpackMode: "eager", webpackExports: ["Portal"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/portal/portal.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/radio-group/radio-group.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/select/select.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/switch/switch.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/tabs/tabs.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/textarea/textarea.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/components/transition/transition.js");
;
import(/* webpackMode: "eager", webpackExports: ["useClose"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@headlessui/react/dist/internal/close-provider.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/(app)/home/images/academy-1.jpg");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/(app)/home/images/data-analyzer-laptop.jpg");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/(app)/home/images/wordcloud-gatsby.jpeg");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/(app)/labs/virtual-ray/images/virtual-ray-profile-photo.jpg");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/domains/about/images/about-v2.webp");
;
import(/* webpackMode: "eager", webpackExports: ["MobileFrameClientSide"] */ "/home/will/Documents/Business/wise/repos/wise/site/domains/layout/components/MobileFrameClientSide.tsx");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/domains/layout/images/wide-logo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/will/Documents/Business/wise/repos/wise/site/domains/users/components/LowerMenuItemDetails.tsx");
